import React, { useEffect, useState } from "react";
import { Checkbox, Empty, Modal, Spin } from "antd";
import RequestHandler from "util/RequestHandler";
import {
  trackBannerClick,
  resolveBannerTargetUrl,
  openBannerTarget,
  BANNER_SCREEN_POPUP,
  PANEL_TYPE_B2B,
  FINIKA_REGISTER_URL,
} from "util/BannerClickActions";
import { dismissBannerPromoFor1Week } from "util/BannerPromoSession";
import { GiftOutlined } from "@ant-design/icons";
import FinekraOzelBadge from "assets/images/finekra-ozel-badge.png";
import "./BannerPromoModal.css";

const BannerPromoIcon = (props) => <GiftOutlined {...props} aria-hidden />;

const formatDecimal = (value) => {
  if (value == null) return null;
  return Number(value).toLocaleString("tr-TR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const BannerPromoModal = ({ visible, onCancel, tenantId = null }) => {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dismissChecked, setDismissChecked] = useState(false);

  useEffect(() => {
    if (!visible) {
      setBanners([]);
      setDismissChecked(false);
      return;
    }

    let cancelled = false;
    setLoading(true);

    let url = "/Banner/GetActiveB2B";
    if (tenantId) {
      url += "?tenantId=" + tenantId;
    }

    RequestHandler.get(url)
      .then((response) => {
        if (cancelled) return;
        const list = Array.isArray(response) ? response : [];
        setBanners(list.filter((b) => b && b.imagePath));
      })
      .catch(() => {
        if (!cancelled) setBanners([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [visible, tenantId]);

  const handleBannerClick = (banner) => {
    trackBannerClick({
      bannerId: banner.id,
      screenName: BANNER_SCREEN_POPUP,
      panelType: PANEL_TYPE_B2B,
      firmId: null,
    });
    const target = resolveBannerTargetUrl(banner, { isLogin: true });
    openBannerTarget(target);
  };

  const handleClose = () => {
    if (dismissChecked) {
      dismissBannerPromoFor1Week();
    }
    onCancel();
  };

  return (
    <Modal
      visible={visible}
      onCancel={handleClose}
      footer={null}
      width="90vw"
      style={{ maxWidth: 920 }}
      destroyOnClose
      title={
        <span className="banner-promo-modal-title">
          <BannerPromoIcon style={{ fontSize: 20 }} />
          Kampanyalar
          {banners.length > 0 && (
            <span className="banner-promo-modal-count">
              İşletmen için seçtiğimiz {banners.length} fırsat
            </span>
          )}
        </span>
      }
    >
      <Spin spinning={loading}>
        <div className="banner-promo-modal-list">
          {!loading && banners.length === 0 ? (
            <Empty description="Aktif kampanya bulunamadı" />
          ) : (
            banners.map((banner) => (
              <div
                key={banner.id}
                className="banner-promo-card"
                onClick={() => handleBannerClick(banner)}
                role="button"
                tabIndex={0}
              >
                <div className="banner-promo-card-image-wrapper">
                  <img
                    src={FinekraOzelBadge}
                    alt="Finekra'ya Özel"
                    className="banner-promo-card-badge banner-promo-card-badge--overlay"
                  />
                  <img
                    src={banner.imagePath}
                    alt={banner.name || "banner"}
                    className="banner-promo-card-image"
                  />
                </div>
                <div className="banner-promo-card-info">
                  <img
                    src={FinekraOzelBadge}
                    alt=""
                    aria-hidden={true}
                    className="banner-promo-card-badge banner-promo-card-badge--in-info"
                  />
                  <div className="banner-promo-card-name">
                    {banner.bankName && (
                      <span className="banner-promo-card-bank">
                        {banner.bankName}
                      </span>
                    )}
                    {banner.bankName && " · "}
                    <span className="banner-promo-card-campaign">
                      {banner.name || "Kampanya"}
                    </span>
                  </div>
                  <div className="banner-promo-card-details">
                    <div className="banner-promo-card-detail">
                      <span className="banner-promo-card-detail-value">
                        {banner.interestRate != null
                          ? `%${formatDecimal(banner.interestRate)}`
                          : "—"}
                      </span>
                      <span className="banner-promo-card-detail-label">
                        Faiz Oranı
                      </span>
                    </div>
                    <div className="banner-promo-card-detail">
                      <span className="banner-promo-card-detail-value">
                        {banner.totalAmount != null
                          ? `${formatDecimal(banner.totalAmount)} TL`
                          : "—"}
                      </span>
                      <span className="banner-promo-card-detail-label">
                        Toplam Tutar
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>

        {!loading && banners.length > 0 && (
          <div className="banner-promo-modal-footer">
            <div className="banner-promo-modal-dismiss">
              <Checkbox
                checked={dismissChecked}
                onChange={(e) => setDismissChecked(e.target.checked)}
              >
                7 gün boyunca gösterme
              </Checkbox>
              <p className="banner-promo-modal-dismiss-hint">
                Kampanyalara istediğiniz zaman sağ üstteki hediye paketi
                simgesinden erişebilirsiniz.
              </p>
            </div>
            <button
              type="button"
              className="banner-promo-all-link"
              onClick={() =>
                window.open(
                  FINIKA_REGISTER_URL,
                  "_blank",
                  "noopener,noreferrer",
                )
              }
            >
              Tüm kampanyalar &rsaquo;
            </button>
          </div>
        )}
      </Spin>
    </Modal>
  );
};

export { BannerPromoIcon };
export default BannerPromoModal;
